// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3fRPT","title":"Info_title__2HZp9","links":"Info_links__1RHPn","link":"Info_link__T6JlJ","logo":"Info_logo__2NKLt"};